import { render, staticRenderFns } from "./AddListButton.vue?vue&type=template&id=1a68040b&"
import script from "./AddListButton.vue?vue&type=script&lang=ts&"
export * from "./AddListButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports